<input class="form-control" data-cy="educationName" (click)="showDropdown = true" [ngClass]="{'loading' : isLoading}" [value]="value" [formControl]="searchControl" (blur)="closeDropdown(200)" />
<div class="dropdown" [ngClass]="{show : showDropdown}">

  <div class="dropdown-menu" [ngClass]="{show : isLoading}">
    <div class="dropdown-item">
      <fa-icon></fa-icon> {{'Loading...' | translate}}
    </div>
  </div>

  <div *ngIf="data.length > 0" class="dropdown-menu" style="max-height: 300px; overflow-y: auto" [ngClass]="{show : showDropdown && !isLoading}">

    <div class="dropdown-item cursor-pointer" *ngFor="let row of data" (click)="onSelect(row)">
      <span class="font-weight-bold">{{row['name']}}</span>
      <div class="extra-info">
        <span *ngIf="row['suffix']">
          {{row['suffix']}}
        </span>
      </div>
    </div>

  </div>

</div>
